const TRANSLATION = {
  buyModal: {
    afterFree: 'После бесплатной пробной версии',
    btn: 'Попробуйте бесплатно',
    freeTrial: '3-дневная бесплатная пробная версия',
    monthLabel: 'месяц',
    selectLabel: 'Выберите план',
    title: 'План подписки',
    yearLabel: 'год',
  },
  contact: {
    block1:
      'По вопросам настройки, вопросам или предложениям обращайтесь к нам по адресу contact@noam.tools. Мы ответим оперативно.',
    block2: 'Поддержите нас, оценив нас в магазине расширений Google Apps по адресу ★★★★★.',
    block3: 'Помогите другим, поделившись этим расширением:',
    title: 'Связаться с нами',
  },
  help: {
    AquickOverviewOfNoam: 'Краткий обзор Noam',
    ChatPDF: 'Чат PDF',
    ChatPDF2: 'ЧатPDF',
    FavoritesManagement: 'Управление избранным',
    Fixedplugin: 'Исправлен плагин',
    Focusing: 'Фокусировка',
    Free: 'Бесплатно',
    FreeTrialBenefits: 'Преимущества бесплатной пробной версии',
    GoWithWikipedia: 'Идите с Википедией',
    GoWithYouTube: 'Используйте YouTube',
    HoverTranslation: 'Наведите курсор на перевод',
    Howtouse: 'Как использовать',
    ImageTranslation: 'Перевод изображений',
    InstantTranslation: 'Мгновенный перевод',
    Membership: 'Членство',
    NoamHelp: 'Noam помогает вам переводить и обобщать',
    PDFparallelTranslation: 'Параллельный перевод PDF-файлов',
    ParallelTranslation: 'Параллельный перевод',
    SkipAllSteps: 'Пропустить все шаги',
    Summary: 'Краткое содержание',
    Translation: 'Перевод',
    TryItForFree: 'Попробуйте это бесплатно',
    Video: 'Видео',
    VideoSummary: 'Краткое изложение видео',
    VideoTranslation: 'Перевод видео',
    WebSummary: 'Веб-сводка',
    WordSelectionTranslation: 'Перевод выбора слов',
    benefits: 'У нас есть преимущества, которые ждут вас!',
    dayFree: '3-дневная бесплатная пробная версия',
    done: 'Сделанный',
    next: 'Следующий',
    pin: 'Закрепите Noam для облегчения доступа～～',
    planIsNotExist: 'План недоступен',
    startWiki: 'Начнем с Викимедиа!',
    startYoutube: 'Начнем с YouTube!',
    try: 'Попробуйте это',
    tryNow: 'Попробуйте прямо сейчас!',
  },
  home: {
    PDFTranslate: {
      desc: 'Двуязычный перевод + чат PDF',
      sub1: {
        desc: 'Двуязычное чтение позволяет сравнивать исходный текст и перевод, повышая эффективность чтения.',
        title: 'Двуязычное чтение',
      },
      sub2: {
        desc: 'ИИ анализирует и обобщает информацию, а также может ответить на ваши вопросы на основе содержимого PDF-файла.',
        title: 'Чат PDF',
      },
      sub3: {
        desc: 'Перевод PDF-файлов с помощью искусственного интеллекта для большей точности и эффективности.',
        title: 'Точность и эффективность',
      },
      title: 'PDF-переводчик',
    },
    aiAssistant: {
      desc: 'Делаем веб-перевод умнее и удобнее',
      panel1: {
        desc: 'Двуязычные переводы с перекрестными ссылками помогут вам сравнить исходный текст с переводом, чтобы лучше понять и повысить эффективность чтения.',
        title: 'Двуязычный перевод',
      },
      panel2: {
        left: {
          desc: 'При просмотре веб-страницы наведите указатель мыши на контент, который необходимо перевести, чтобы увидеть перевод.',
          title: 'Наведите курсор на перевод',
        },
        right: {
          desc: 'При просмотре веб-страницы выберите текст, который хотите перевести, чтобы просмотреть перевод.',
          title: 'Перевод выделенного текста',
        },
      },
      panel3: {
        one: {
          desc: 'Переводите и обобщайте веб-страницы и видеоконтент в любое время и в любом месте для более удобной работы!',
          title: 'Укажите и щелкните',
        },
        three: {
          desc: 'Модель большого языка, управляемая искусственным интеллектом, обеспечивает точность и согласованность перевода, повышая удобство чтения.',
          title: 'Управляемый искусственным интеллектом',
        },
        two: {
          desc: 'Полный охват нескольких языков, двуязычное безбарьерное чтение, перевод одним щелчком мыши — почувствуйте разницу!',
          title: 'Более комплексный и удобный',
        },
      },
      panel4: {
        tab1: {
          desc: 'Ваш эксперт по эффективности: с помощью ChatGPT Noam переводит и обобщает видеоконтент YouTube, чтобы сэкономить ваше время!',
          key: 'Видео',
          title: 'Перевод видео и краткое изложение',
        },
        tab2: {
          desc: 'Нажмите, чтобы перевести изображения во время просмотра веб-страниц.',
          key: 'Изображение',
          title: 'Перевести изображения',
        },
        tab3: {
          desc: 'Мгновенно извлекает ключевую информацию с веб-страниц и предоставляет сводку, повышая эффективность чтения.',
          key: 'Интернет',
          title: 'Веб-перевод и резюме',
        },
        tag1: 'Простой',
        tag2: 'Эффективный',
        tag3: 'Легко понять',
      },
      title: 'ИИ-помощник',
    },
    getStart: 'Начать',
    getStartedForFree: 'Начните бесплатно',
    howItWork: {
      desc: 'Noam интегрирует модели искусственного интеллекта, чтобы предоставить пользователям интеллектуальные возможности для перевода и обобщения веб-страниц на разных языках, перевода PDF-файлов и изображений, перевода и обобщения видео.',
      title: 'Как это работает',
    },
    lastBlock: { desc: 'Лучший перевод AI для более плавного чтения' },
    top: {
      desc: 'Noam — это бесплатное расширение браузера с искусственным интеллектом, которое помогает переводить и обобщать веб-страницы, видео и PDF-контент.\\n Присоединяйтесь к Noam и испытайте волшебство!',
      title1: 'Одна магия',
      title2: 'Один клик',
    },
    userReviews: {
      desc: 'Пятизвездочные отзывы в Интернет-магазине Chrome',
      title: 'Отзывы пользователей',
    },
  },
  installTips: {
    btn: 'Попробуйте сейчас',
    text: 'Установите «Noam Browser Plugin», чтобы разблокировать больше функций! Перекрестные ссылки в Интернете, обобщение веб-видео и многое другое!',
  },
  locale: {
    af: 'африкаанс',
    am: 'амхарский',
    ar: 'арабский',
    as: 'Ассамский',
    auto: 'Автоматическое обнаружение',
    az: 'азербайджанский',
    ba: 'Башкирский',
    bg: 'болгарский',
    bn: 'Бангла',
    bo: 'тибетский',
    bs: 'Боснийский',
    ca: 'каталонский',
    cs: 'чешский',
    cy: 'валлийский',
    da: 'датский',
    de: 'немецкий',
    dsb: 'Нижнесербский',
    dv: 'Дивехи',
    el: 'Греческий',
    en: 'Английский',
    es: 'испанский',
    et: 'эстонский',
    eu: 'Баскский',
    fa: 'персидский',
    fi: 'финский',
    fil: 'Филиппинский',
    fj: 'Фиджийский',
    fr: 'Французский',
    frCA: 'Французский (Канада)',
    ga: 'ирландский',
    gl: 'галисийский',
    gom: 'Конкани',
    gu: 'Гуджарати',
    ha: 'Хауса',
    he: 'иврит',
    hi: 'хинди',
    hr: 'хорватский',
    hsb: 'Верхнелужский',
    ht: 'гаитянский креольский',
    hu: 'венгерский',
    hy: 'Армянский',
    id: 'индонезийский',
    ig: 'Игбо',
    ikt: 'Инуиннактун',
    is: 'исландский',
    it: 'итальянский',
    iu: 'Инуктитут',
    iuLatn: 'Инуктитут (латиница)',
    ja: 'японский',
    ka: 'грузинский',
    kk: 'казахский',
    km: 'кхмерский',
    kmr: 'Курдский (Северный)',
    kn: 'Каннада',
    ko: 'корейский',
    ku: 'Курдский (Центральный)',
    ky: 'киргизский',
    ln: 'Лингала',
    lo: 'Лаосский',
    lt: 'литовский',
    lug: 'Ганда',
    lv: 'латышский',
    lzh: 'Китайский (литературный)',
    mai: 'Майтхили',
    mg: 'малагасийский',
    mi: 'Маори',
    mk: 'македонский',
    ml: 'малаялам',
    mnCyrl: 'Монгольский (кириллица)',
    mnMong: 'Монгольский (традиционный)',
    mr: 'Маратхи',
    ms: 'малайский',
    mt: 'мальтийский',
    mww: 'Хмонг Доу',
    my: 'Мьянма (бирманский)',
    nb: 'норвежский',
    ne: 'непальский',
    nl: 'Голландский',
    noSearchLang: 'Язык не поддерживается',
    nso: 'Сесото са Лебоа',
    nya: 'Ньянджа',
    or: 'Одия',
    otq: 'Керетаро Отоми',
    pa: 'панджаби',
    pl: 'Польский',
    placeholder: 'Поиск',
    prs: 'Дари',
    ps: 'пушту',
    pt: 'Португальский (Бразилия)',
    ptPT: 'Португальский (Португалия)',
    ro: 'румынский',
    ru: 'Русский',
    run: 'Рунди',
    rw: 'Киньяруанда',
    sd: 'Синдхи',
    si: 'сингальский',
    sk: 'словацкий',
    sl: 'словенский',
    sm: 'Самоанец',
    sn: 'Шона',
    so: 'Сомали',
    sq: 'албанский',
    srCyrl: 'Сербский (кириллица)',
    srLatn: 'Сербский (латиница)',
    st: 'сесото',
    sv: 'Шведский',
    sw: 'суахили',
    ta: 'тамильский',
    te: 'телугу',
    th: 'тайский',
    ti: 'Тигринья',
    tk: 'туркменский',
    tlhLatn: 'Клингонский (латиница)',
    tlhPiqd: 'Клингонский (pIqaD)',
    tn: 'Сетсвана',
    to: 'Тонга',
    tr: 'турецкий',
    tt: 'татарский',
    ty: 'таитянский',
    ug: 'уйгурский',
    uk: 'Украинский',
    ur: 'Урду',
    uz: 'Узбекский (латиница)',
    vi: 'вьетнамский',
    xh: 'коса',
    yo: 'Йоруба',
    yua: 'Юкатек Майя',
    yue: 'Кантонский диалект (традиционный)',
    zh: 'китайский',
    zhHans: 'Китайский упрощенный',
    zhHant: 'Китайский Традиционный',
    zu: 'Зулу',
  },
  login: {
    and: 'и',
    btn: 'Войти через Google',
    btn1: 'Войти сейчас',
    desc: 'Войдите, чтобы разблокировать больше возможностей',
    policy: 'политика конфиденциальности',
    terms: 'Условия эксплуатации',
    tips: 'Регистрируясь, я соглашаюсь с',
    title: 'Добро пожаловать в Ноам',
  },
  pageFooter: {
    follow: { facebook: 'Фейсбук', title: 'Следовать', twitter: 'Твиттер' },
    legal: {
      policy: 'политика конфиденциальности',
      terms: 'Условия использования',
      title: 'Юридический',
    },
    product: {
      image: 'Перевод изображений',
      pdf: 'ERROR: [PDF Translation]',
      title: 'Продукты',
      video: 'Перевод видео и краткое изложение',
      web: 'Веб-перевод и резюме',
    },
    resources: { title: 'Ресурсы' },
  },
  pageHeader: {
    contact: 'Контакт',
    help: 'Помощь',
    logout: 'Выйти',
    logoutSucc: 'Вышел из системы.',
    pricing: 'Цены',
    settings: 'Настройки',
    signUp: 'Авторизоваться',
  },
  pdf: {
    autoDetect: 'Автоопределение',
    cancelBtn: 'Отмена',
    cancelUpload: 'Отмена',
    chatPdf: {
      Search: 'Поиск',
      cancel: 'Отмена',
      chatTitle: 'Добро пожаловать в Ноам! Вот краткое описание вашего PDF-файла:',
      clear: 'Прозрачный',
      clearContent: 'Это начнет новый разговор. Текущий разговор не будет сохранен. Вы уверены?',
      clearDialogTitle: 'Пожалуйста, подтвердите',
      clearSucc: 'Очищено',
      copy: 'Копировать',
      copySucc: 'Скопировано',
      delete: 'Удалить',
      deleteCancel: 'Отмена',
      deleteContent: 'Этот PDF-файл невозможно восстановить после удаления. Вы уверены?',
      deleteOk: 'Удалить',
      deleteSuccess: 'Удалено',
      deleteTitle: 'Подтвердить удаление',
      expand: 'Крах',
      historyTitle: 'История',
      listError:
        'Не удалось загрузить список чтения. Пожалуйста, повторите попытку позже или обратитесь в службу поддержки.',
      loading: 'Загрузка...',
      noDataDesc: 'Истории пока нет.',
      noMore: 'Больше никакого контента.',
      placeholder: 'Спросите что-нибудь об этом PDF-файле',
      summaryTitle: 'Возможно, вас заинтересуют эти вопросы:',
    },
    collectionEmpty: 'Ваша коллекция пуста.',
    collectionTab: 'Примечания',
    dataLoading: 'Загрузка...',
    dialogContent: 'Вы уверены, что хотите удалить это?',
    dialogTitle: 'Пожалуйста, подтвердите',
    download: {
      both: 'Двуязычный',
      btn: 'Сохранять',
      cancel:
        'Закрытие этого окна приведет к отмене загрузки PDF. Вы уверены, что хотите отменить?',
      desc: 'Сохранить на устройство: загружает переводы в виде изображений; Сохранить и распечатать: загружает переводы в исходном формате с поддержкой копирования.',
      download: 'Скачать',
      downloadMsg1: 'Ход перевода PDF:',
      downloadMsg2: 'Примерное оставшееся время:',
      downloadSucc: 'PDF готов! Нажмите, чтобы сохранить.',
      downloadTip: 'Скачивание PDF. Не закрывайте это окно, чтобы избежать ошибок загрузки.',
      error: 'Не удалось сохранить. Вместо этого попробуйте распечатать.',
      fileName: 'Имя файла:',
      fileType: 'Тип файла:',
      loading: 'Сохранение...',
      loading2: 'Загрузка...',
      minute: 'Минуты...',
      msg1: 'Некоторые переводы в этом документе длиннее исходного текста и могут перекрываться в загруженном файле. Рекомендуем прочитать на сайте.',
      msg2: '1. Перевод еще не завершен. Пожалуйста, скачайте после завершения перевода.',
      msg3: '2. Некоторые переводы слишком длинные. Читайте на веб-странице, чтобы избежать дублирования текста.',
      msg4: 'Задачи по переводу выполняются. Пожалуйста, повторите попытку после того, как они будут завершены.',
      progress:
        'Перевод PDF. Прогресс: {{progress}}. Оставшееся примерное время: {{минуты}} минут...',
      save: 'Сохранить на устройство',
      savePrint: 'Сохранить и распечатать',
      success: 'Скачано',
      trans: 'Только перевод',
      transContinue: 'Продолжить перевод',
    },
    downloadBtn: 'Скачать',
    dragTipModal: {
      black: 'космос',
      leftKey: 'левая кнопка',
      ok: 'Понятно',
      press: 'Нажимать',
      tips: 'перетащить и просмотреть.',
    },
    entry: 'PDF-файлы',
    fileErrMsg:
      'Чтение файла не удалось. Повторите попытку позже или обратитесь в службу поддержки.',
    fileMsg: 'Текущий размер файла:',
    fileMsg2: 'Пожалуйста, загрузите файл размером менее 300 МБ.',
    freeBannerBtn: 'Обновление',
    freeBannerTips: 'Достигнут лимит бесплатных PDF-переводов',
    guide: {
      placeholder: 'Вставьте ссылку PDF сюда',
      start: 'Начать перевод',
      text1: 'Двуязычное чтение',
      text2:
        'Читайте на двух языках, чтобы сравнивать исходный текст и перевод, повышая свою эффективность.',
      text3: 'Общайтесь со своим PDF-файлом',
      text4:
        'Анализ и обобщение с помощью искусственного интеллекта. Задавайте вопросы о вашем PDF-файле и получайте мгновенные ответы.',
      text5: 'Точный и эффективный',
      text6:
        'Перевод PDF-файлов с помощью искусственного интеллекта для большей точности и эффективности.',
      title1: 'Двуязычный перевод',
      title2: 'Общайтесь со своим PDF-файлом',
      toast: 'Введите действительную онлайн-ссылку PDF, заканчивающуюся на .pdf.',
    },
    hasTransTask: 'Выполняется задача перевода. Пожалуйста, подождите.',
    hoverTrans: 'Наведите указатель мыши на перевод абзацев',
    initial: 'Перевести PDF',
    installText: 'Ваше универсальное решение для повседневных переводов.',
    installText2: 'Пожалуйста, сначала установите расширение',
    installTips:
      'Установите расширение, чтобы получить еще больше переводов PDF и более плавный перевод веб-сайтов:',
    kw: 'штапель',
    link: 'связь',
    listError:
      'Не удалось загрузить PDF-файлы. Пожалуйста, повторите попытку позже или обратитесь в службу поддержки.',
    memoTotalCount: 'всего 1 предмет',
    new: 'новый файл',
    noId: 'Идентификатор файла не найден.',
    notPdf: 'Только PDF-файлы.',
    okBtn: 'Удалить',
    okBtn2: 'Понятно',
    original: 'Оригинал',
    parallel: 'Параллельно',
    parseErrDialogContent:
      'Эту ссылку PDF невозможно перевести напрямую. Загрузите PDF-файл и загрузите его для перевода.',
    parseErrTips: 'Не удалось проанализировать файл',
    parseFileToast:
      'Не удалось проанализировать файл. Повторите попытку позже или обратитесь в службу поддержки.',
    pdfLoading: 'Разбор...',
    searchPlaceholder: 'Поиск',
    selectTrans: 'Выберите текст для перевода',
    shareBtn: 'Делиться',
    shareBtnText1: 'Создать ссылку для общего доступа',
    shareBtnText2: 'Обновить общий контент',
    shareModal: {
      cancel: 'Отмена',
      copy: 'Копировать',
      copySucc: 'Ссылка скопирована',
      custom: 'Настроить:',
      errMsg:
        'Выбранный контент еще не полностью переведен. Пожалуйста, переведите, прежде чем делиться.',
      gen: 'Делиться',
      modify: 'Редактировать',
      notSupport: 'Этот язык в настоящее время не поддерживается.',
      page: 'Страницы',
      pageNuErr: 'Пожалуйста, введите действительный номер страницы.',
      range: 'Объем:',
      remain: 'оставшийся',
      remain1: 'Общее расчетное время:',
      search: 'Поиск',
      settings: 'Настройки общего доступа:',
      shareSetting: 'Поделиться настройками',
      shareText: 'Делиться',
      shareTips: 'Поделитесь ссылкой на переведенный PDF-файл с друзьями:',
      sourceLang: 'От:',
      target: 'К:',
      text1: 'Поделиться настройками',
      text2: 'Создать ссылку для общего доступа',
      totalPage: 'всего 1 страница',
      trans: 'Переводить',
      translateTips:
        'Совет: Если перевод занимает некоторое время, вы можете закрыть это окно и поделиться им позже.',
      translating: 'Перевод PDF...',
      update: 'Обновить ссылку для общего доступа',
    },
    shareMsg1: 'Ссылка для общего доступа создана.',
    shareMsg2: 'Общий контент обновлен.',
    shareMsg3:
      'Не удалось создать ссылку для общего доступа. Повторите попытку позже или обратитесь в службу поддержки.',
    shareMsg4:
      'Не удалось обновить общий контент. Пожалуйста, повторите попытку позже или обратитесь в службу поддержки.',
    shareTips: 'Ваш PDF-перевод готов! Поделитесь этим с друзьями.',
    start: 'Начните бесплатную пробную версию',
    thumbnail: 'Оглавление',
    toast1: 'Загрузка PDF. Пожалуйста, повторите попытку позже.',
    toast2: 'Содержимое PDF слишком велико. Диалог в настоящее время не поддерживается.',
    toast3: 'Загрузка. Пожалуйста, повторите попытку после завершения загрузки.',
    toolbar: { Adjust: 'Регулировать', autoFit: 'Автоподбор' },
    trans: 'Перевод',
    transSucc: 'Перевод успешен!',
    unLoginToast: 'Пожалуйста, войдите, чтобы использовать эту функцию.',
    uploadBtn: 'Загрузить',
    uploadErr:
      'Загрузка файла не удалась. Повторите попытку позже или обратитесь в службу поддержки.',
    uploadMsg1: 'Перетащите сюда свой файл.',
    uploadMsg2: 'Поддерживаемые типы файлов: PDF |  Максимальный размер файла: 100 МБ',
    uploadMsg3: 'Нажмите, чтобы выбрать или перетащить сюда файлы.',
    uploading: 'Загрузка',
    uploadingMsg: 'Загрузка. Пожалуйста, подождите.',
    uploadingMsg1: 'Файл загружается. Пожалуйста, повторите попытку позже.',
    uploadingMsg2: 'В настоящее время файл конвертируется. Пожалуйста, повторите попытку позже.',
    uploadingMsg3:
      'Запрос о ходе преобразования не выполнен. Повторите попытку позже или обратитесь в службу поддержки.',
    uploadingMsg4:
      'Noam не может получить доступ к локальным файлам. Загрузите PDF-файл для перевода вручную.',
    uploadingMsg5:
      'Не удалось получить URL-адрес файла. Повторите попытку позже или обратитесь в службу поддержки.',
    video: 'видео',
    vipBannerBtn: 'Обновление',
    vipBannerTips: 'Вы достигли лимита на переводы PDF в этом месяце.',
    webTrans: 'Полная перекрестная ссылка',
  },
  pricing: {
    FAQ: 'Часто задаваемые вопросы',
    FQAObj: {
      a1: 'Да, Noam предлагает бесплатный план, которым вы можете воспользоваться прямо сейчас.',
      a2: 'Мы предлагаем три плана членства: Pro, Pro+ и Enterprise. Вы можете выбрать оплату ежемесячно или ежегодно. Ежегодное выставление счетов обеспечивает значительную экономию.',
      a3: 'Все функции доступны в обоих планах. Основное отличие заключается в стоимости: годовая подписка в целом стоит дешевле. Счета за ежемесячные подписки выставляются каждый месяц, а за годовые планы — один раз в год.',
      a4: 'Вы можете отменить подписку в любое время в настройках своей учетной записи.',
      q1: 'Есть ли бесплатный план?',
      q2: 'Какие тарифные планы и варианты оплаты доступны?',
      q3: 'В чем разница между ежемесячной и годовой подпиской?',
      q4: 'Как мне отменить подписку?',
    },
    around: 'Вокруг',
    billedMonthly: 'Оплата ежемесячно',
    billedYearly: 'Оплата ежегодно',
    day: 'день',
    desc: 'Сравните планы и выберите лучший',
    detailedCompare: 'Сравнить планы',
    discount: 'Скидка 20%',
    enterprise: {
      benefit1: 'Приоритетная поддержка клиентов',
      benefit2: 'Несколько пользователей',
      benefit3: 'Индивидуальные решения',
      benefit5: 'Персональный менеджер по работе с клиентами',
      btn: 'Связаться с нами',
      recommendText: 'Индивидуальные планы (≥3 人)',
      talkToUs: 'Свяжитесь с нами',
    },
    free: {
      benefit1: 'Мгновенный перевод 100 раз/день',
      benefit2: 'Перевод веб-сайта и резюме',
      benefit3: '30 переводов изображений',
      benefit4: 'Перевод видео и краткое изложение',
      benefit5: '10 PDF-переводов',
      benefit6: '5000 жетонов',
      btn: 'Попробуйте бесплатно',
      recommendText: 'Бесплатная пробная версия',
    },
    imageTranslation: 'Перевод изображений',
    month: 'месяц',
    monthly: 'Ежемесячно',
    pageTitle: 'Цены',
    pdf: { chat: 'PDF-запросы в чате', maxPage: 'Макс. Страниц в PDF', translation: 'PDF-перевод' },
    preMonth: 'Помесячно',
    pro: {
      benefit1: 'Приоритетная поддержка клиентов',
      benefit2: '1 000 000 токенов/месяц',
      benefit3: 'Перевод веб-сайта и резюме',
      benefit4: '200 переводов изображений',
      benefit5: 'Перевод видео и краткое изложение',
      benefit6: '200 PDF-переводов',
      btn: 'Начать',
      recommendText: 'Самый популярный',
    },
    proPlus: {
      benefit1: 'Приоритетная поддержка клиентов',
      benefit2: '3 000 000 токенов/месяц',
      benefit3: 'Перевод веб-сайта и резюме',
      benefit4: '500 переводов изображений',
      benefit5: 'Перевод видео и краткое изложение',
      benefit6: '500 PDF-переводов',
      recommendText: 'Лучшее соотношение цены и качества',
    },
    video: { summary: 'Краткое изложение видео', translation: 'Перевод видео' },
    web: {
      contrastiveTranslation: 'Двуязычный перевод',
      dictionaryTranslation: 'Перевод выбора',
      hoverTranslation: 'Наведите курсор на перевод',
      instantTranslation: 'Мгновенный перевод',
      summary: 'Сводка веб-страницы',
    },
    yearly: 'Ежегодно',
  },
  privacy: {
    block1:
      'Noam («Ноам», «мы», «наш» или «нас») уважает вашу конфиденциальность и обязуется защищать любую информацию, которую мы получаем от вас или о вас. В настоящей Политике конфиденциальности описаны наши методы сбора или использования личной информации, полученной в результате использования вами нашего веб-сайта, приложений и услуг (совместно именуемых «Услуги»). Настоящая Политика конфиденциальности не распространяется на контент, который мы обрабатываем от имени клиентов наших бизнес-продуктов, таких как наш API. Использование этих данных регулируется нашим клиентским соглашением, которое охватывает доступ к этим продуктам и их использование.',
    block10:
      'Мы реализуем коммерчески разумные технические, административные и организационные меры для защиты личной информации онлайн и оффлайн от потери, неправильного использования и несанкционированного доступа, раскрытия, изменения или враждебных действий. Однако никакая передача данных через Интернет или электронную почту не может гарантировать полную безопасность и точность. В частности, электронные письма, отправленные нам или от нас, могут быть небезопасными. Поэтому вам следует быть особенно осторожным при принятии решения о том, какую информацию отправить нам через службу или по электронной почте. Кроме того, мы не несем ответственности за какие-либо препятствия настройкам конфиденциальности или мерам безопасности в сервисе или настройкам безопасности или мерам безопасности сторонних веб-сайтов. Мы будем хранить вашу личную информацию до тех пор, пока это необходимо для предоставления вам услуг или для других законных деловых целей, таких как разрешение споров, соображения безопасности или выполнения наших юридических обязательств. Продолжительность времени, в течение которого мы храним личную информацию, будет зависеть от многих факторов, таких как объем, характер, конфиденциальность информации, потенциальные риски несанкционированного использования или раскрытия, цели, для которых мы обрабатываем информацию, а также другие юридически обязательные соображения.',
    block11:
      'Мы можем время от времени обновлять настоящую Политику конфиденциальности. Когда мы это сделаем, мы опубликуем обновленную версию на этой странице, если иное не предусмотрено применимым законодательством.',
    block12:
      'Если у вас остались вопросы или сомнения по поводу настоящей Политики конфиденциальности, свяжитесь с нашей службой поддержки клиентов. Электронная почта:',
    block2: 'Мы собираем следующую личную информацию («Личная информация»), связанную с вами:',
    block3:
      'Информация, предоставленная вами: Когда вы создаете учетную запись для использования наших услуг или общения с нами, мы собираем личную информацию следующим образом:',
    block4:
      'Личная информация, автоматически полученная при использовании вами сервисов. Когда вы получаете доступ к сервисам, используете их или взаимодействуете с ними, мы получаем следующую информацию о вашем доступе, использовании или взаимодействии («Техническая информация»):',
    block5: 'Мы можем использовать личную информацию для следующих целей:',
    block6:
      'Сводная или обезличенная информация: мы можем объединять или обезличивать личную информацию, чтобы предотвратить ее повторное использование в целях идентификации, и использовать такую ​​информацию для анализа эффективности наших услуг, улучшения и добавления функций в наши услуги, проведения исследований и в аналогичных целях. . Кроме того, мы можем анализировать общее поведение и характеристики пользователей наших услуг и передавать агрегированную информацию третьим лицам, публиковать такую ​​агрегированную информацию или делать ее общедоступной. Мы можем собирать агрегированную информацию с помощью сервисов, файлов cookie и других средств, описанных в настоящей Политике конфиденциальности. Мы будем хранить и использовать обезличенную информацию в анонимной или обезличенной форме и не будем пытаться повторно идентифицировать такую ​​информацию, если этого не требует закон.',
    block7:
      'В определенных случаях мы можем предоставить вашу личную информацию третьим лицам без предварительного уведомления, если это не требуется по закону:',
    block8:
      'В зависимости от вашего географического положения люди в Европейской экономической зоне, Великобритании и во всем мире могут иметь определенные законные права в отношении своей личной информации. Например, вы можете иметь право:',
    block9:
      'Служба может содержать ссылки на другие веб-сайты, которые не управляются и не контролируются Noam, включая службы социальных сетей («Сторонние веб-сайты»). Информация, которой вы делитесь со Сторонними веб-сайтами, будет регулироваться конкретной политикой конфиденциальности и условиями обслуживания Сторонних веб-сайтов, а не настоящей Политикой конфиденциальности. Мы предоставляем эти ссылки для удобства и не подразумеваем, что мы одобряем или проверяем эти веб-сайты. Пожалуйста, свяжитесь со сторонними веб-сайтами напрямую для получения информации об их политике и условиях конфиденциальности.',
    subBlock1:
      'Информация об учетной записи: когда вы создаете учетную запись на нашей платформе, мы собираем информацию, связанную с вашей учетной записью, включая ваше имя, контактную информацию, учетные данные учетной записи, информацию о платежной карте и историю транзакций («Информация об учетной записи»).',
    subBlock10: 'Предоставление, управление, обслуживание и/или анализ услуг;',
    subBlock11: 'Общение с вами;',
    subBlock12: 'Разработка новых продуктов и услуг;',
    subBlock13:
      'Предотвращение мошенничества, преступной деятельности или неправомерного использования наших услуг, а также защита безопасности наших ИТ-систем, архитектуры и сетей;',
    subBlock14: 'Осуществление деловых трансферов;',
    subBlock15:
      'Соблюдение юридических обязательств и судебных разбирательств, защита наших прав, конфиденциальности, безопасности или собственности, а также прав, прав, конфиденциальности, безопасности или собственности наших аффилированных лиц, вас или других третьих лиц.',
    subBlock16:
      'Поставщики и провайдеры услуг. Чтобы помочь нам в удовлетворении операционных потребностей бизнеса и выполнении определенных услуг и функций, мы можем предоставлять личную информацию поставщикам и поставщикам услуг, включая поставщиков услуг хостинга, поставщиков облачных услуг и других поставщиков услуг информационных технологий, программного обеспечения для связи по электронной почте. и поставщики услуг веб-аналитики и т. д. Эти партнеры будут получать доступ, обрабатывать или хранить личную информацию только по нашему указанию при выполнении своих обязанностей для нас.',
    subBlock17:
      'Передача бизнеса: Если мы участвуем в стратегических транзакциях, реорганизациях, банкротствах, поглощениях или передаче услуг другому поставщику (совместно именуемые «Транзакции»), ваша личная информация и другая информация могут быть переданы партнерам по транзакции и другим сторонам, помогающим в транзакциях. в ходе комплексной проверки и переданы в рамках Сделок вместе с другими активами правопреемнику или дочерней компании.',
    subBlock18:
      'Юридические требования: Мы можем передавать вашу личную информацию государственным органам, коллегам из отрасли или другим третьим лицам, включая информацию о вашем взаимодействии с нашими услугами, (1) если этого требует закон или если мы считаем, что такие действия необходимы для соблюдения юридических обязательств; (2) для защиты и защиты наших прав или собственности; (3) если мы в одностороннем порядке определим, что имеет место нарушение наших условий, политик или законов; (4) для обнаружения или предотвращения мошенничества или другой незаконной деятельности; (5) для защиты наших продуктов, сотрудников или пользователей, а также общественной безопасности, защищенности и целостности; или (vi) для защиты от юридической ответственности.',
    subBlock19:
      'Получите доступ к вашей личной информации и информации о том, как она обрабатывается.',
    subBlock2:
      'Пользовательский контент: когда вы пользуетесь нашими услугами, мы собираем личную информацию на основе ваших данных, загрузок файлов или отзывов, предоставленных нам («Контент»).',
    subBlock20: 'Попросите удалить вашу личную информацию из наших записей.',
    subBlock21: 'Исправьте или обновите вашу личную информацию.',
    subBlock22: 'Передача вашей личной информации третьему лицу (переносимость данных).',
    subBlock23: 'Ограничьте обработку вашей личной информации.',
    subBlock24:
      'Отозвать свое согласие. Если мы полагаемся на согласие в качестве правовой основы для обработки, вы можете отозвать свое согласие в любое время.',
    subBlock25: 'Возразить против того, как мы обрабатываем вашу личную информацию.',
    subBlock26: 'Улучшение наших услуг и проведение исследований;',
    subBlock3:
      'Информация для связи. Если вы отправляете нам сообщения, мы собираем ваше имя, контактную информацию и содержание ваших сообщений («Информация для связи»).',
    subBlock4:
      'Информация о социальных сетях: у нас есть страницы на сайтах социальных сетей, таких как Instagram, Facebook, Medium, Twitter, YouTube и LinkedIn. Когда вы взаимодействуете с нашими страницами в социальных сетях, мы собираем личную информацию, которую вы предоставляете нам, например ваши контактные данные («Социальная информация»). Кроме того, компании, размещающие наши страницы в социальных сетях, могут предоставлять нам совокупную информацию и анализ нашей деятельности в социальных сетях.',
    subBlock5:
      'Данные журнала: информация, автоматически отправляемая вашим браузером при использовании наших услуг. Данные журнала включают ваш адрес интернет-протокола (IP), тип и настройки браузера, дату и время ваших запросов, а также то, как вы взаимодействуете с нашим веб-сайтом.',
    subBlock6:
      'Данные об использовании: мы можем автоматически собирать информацию об использовании вами службы, например, типы контента, который вы просматриваете или с которым взаимодействуете, используемые вами функции, предпринимаемые вами действия, а также ваш часовой пояс, страну, дату и время доступ, пользовательский агент и версия, тип компьютера или мобильного устройства, а также подключение к вашему компьютеру.',
    subBlock7:
      'Информация об устройстве: сюда входит имя устройства, операционная система, идентификатор устройства и используемый вами браузер. Собираемая информация может зависеть от типа используемого вами устройства и его настроек.',
    subBlock8:
      'Файлы cookie: мы используем файлы cookie для работы и управления нашими услугами, а также для улучшения вашего опыта. «Cookie» — это информация, отправляемая веб-сайтом, который вы посещаете, в ваш браузер. Вы можете настроить свой браузер так, чтобы он принимал все файлы cookie, отклонял все файлы cookie или уведомлял вас о предоставлении файла cookie, чтобы вы могли каждый раз решать, принимать ли его. Однако отказ от файлов cookie может помешать вам использовать или негативно повлиять на отображение или функциональность определенных областей или функций веб-сайта. Для получения дополнительной информации о файлах cookie посетите страницу «Все о файлах cookie».',
    subBlock9:
      'Аналитика: мы можем использовать различные продукты онлайн-аналитики, которые используют файлы cookie, чтобы помочь нам проанализировать, как пользователи используют наши услуги, и улучшить ваш опыт при использовании этих услуг.',
    subTitle1: 'Личная информация, которую мы собираем',
    subTitle2: 'Как мы используем личную информацию',
    subTitle3: 'Раскрытие личной информации',
    subTitle4: 'Ваши права',
    subTitle5: 'Ссылки на другие сайты',
    subTitle6: 'Безопасность и хранение информации',
    subTitle7: 'Изменение Политики конфиденциальности',
    subTitle8: 'Как связаться с нами',
    title: 'политика конфиденциальности',
    updateTime: 'Обновлено: 15 марта 2024 г.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Принять все',
    text: 'Чтобы улучшить ваш опыт, мы используем файлы cookie для персонализации контента и услуг.',
    title: 'Этот сайт использует файлы cookie',
  },
  slogen: 'Самый простой AI-помощник',
  stripe: {
    contact: 'Если у вас возникнут вопросы, свяжитесь с нами по адресу contact@noam.tools!',
    fail: {
      btn: 'Повторить попытку',
      text1: 'Нам не удалось обработать ваш платеж.',
      text2: 'Проверьте подключение и повторите попытку.',
      title: 'Платеж не выполнен',
    },
    succ: {
      btn: 'Пойдем',
      text1: 'Добро пожаловать в Ноам,',
      text2: 'давайте начнем!',
      title: 'Поздравления',
    },
  },
  terms: {
    block1: 'Благодарим вас за использование Ноама!',
    block10:
      '(а) Сборы и выставление счетов. Вы будете платить все сборы («Комиссии») в соответствии с ценами и условиями, указанными на соответствующей странице цен или согласно письменному соглашению между нами. Мы оставляем за собой право исправлять ошибки или ошибки в ценообразовании, даже если мы выставили счета или получили оплату. Вы предоставите полную и точную платежную информацию, включая действительный и авторизованный способ оплаты. Мы будем взимать средства с вашего способа оплаты на периодической основе в соответствии с соглашением, но мы можем обоснованно изменить дату выставления счета. Вы разрешаете компании Noam, ее аффилированным лицам и сторонним платежным системам взимать плату с вашего способа оплаты. Если ваш платеж не пройдет, мы предоставим вам письменное уведомление и можем приостановить доступ к Сервису до получения платежа. Если иное не указано в настоящем соглашении, платежи не подлежат возврату.',
    block11:
      '(б) Налоги. Если не указано иное, Сборы не включают в себя какие-либо федеральные, государственные, местные и иностранные налоги, пошлины и аналогичные начисления («Налоги»). Вы несете ответственность за уплату всех налогов, связанных с вашими покупками, за исключением налогов, основанных на нашей чистой прибыли, за которую мы выставим вам счет. Вы соглашаетесь незамедлительно платить такие Налоги, предоставлять нам юридически действительные заявления о конфиденциальности и получать необходимые согласия на обработку таких данных, а также гарантируете нам, что вы обрабатываете такие данные в соответствии с применимым законодательством.',
    block12:
      '(в) Изменения цен. Мы можем изменить наши цены, уведомив вас через вашу учетную запись и/или наш веб-сайт. Повышение цен вступит в силу сразу после публикации. Любые изменения цен будут применяться к комиссиям для вашей учетной записи после даты вступления изменения в силу.',
    block13:
      '(г) Споры и просроченные платежи. Если вы хотите оспорить какие-либо сборы или налоги, свяжитесь с нами по адресу contact@noam.tools в течение тридцати (30) дней с даты выставления счета.',
    block14:
      '(д) Бесплатное использование. Вы не можете создавать несколько учетных записей для получения бесплатных кредитов. Если мы определим, что вы недобросовестно используете бесплатные кредиты, мы можем взимать с вас стандартную плату или прекратить предоставление доступа к Сервису.',
    block15:
      '(а) Конфиденциальность. Вы можете иметь доступ к конфиденциальной информации Noam. Вы можете использовать конфиденциальную информацию только в соответствии с настоящими условиями для целей использования Сервиса. Вы не имеете права раскрывать конфиденциальную информацию третьим лицам и будете защищать конфиденциальную информацию не менее защитным способом, чем вы защищаете свою собственную аналогичную конфиденциальную информацию, по крайней мере, с разумной осторожностью. Конфиденциальная информация — это закрытая информация, обозначенная Noam как конфиденциальная или которую следует разумно рассматривать как конфиденциальную в данных обстоятельствах, включая программное обеспечение, спецификации и другую закрытую деловую информацию. Конфиденциальная информация не включает информацию, которая: (1) становится общедоступной без вашей вины; (2) вы имели в своем распоряжении без каких-либо обязательств конфиденциальности до получения в соответствии с настоящими условиями; (3) на законных основаниях раскрыта вам третьей стороной без каких-либо обязательств по конфиденциальности; или (4) разработано вами самостоятельно без использования конфиденциальной информации. Вы можете раскрывать конфиденциальную информацию, если этого требует закон, суд или другое правительственное постановление, но вы должны предоставить Noam предварительное письменное уведомление в разумной форме и, насколько это возможно, предпринять разумные усилия для ограничения объема раскрытия, включая оказание нам помощи. в противодействии запросам о раскрытии информации.',
    block16:
      '(б) Безопасность. Вы должны принять разумные и соответствующие меры, чтобы защитить ваш доступ к Сервису и его использование. Если вы обнаружите какие-либо уязвимости или нарушения, связанные с использованием вами Сервиса, вы должны незамедлительно связаться с Noam и предоставить подробную информацию об уязвимости или нарушении.',
    block17:
      '((c) Обработка персональных данных. Если вы используете Сервис для обработки персональных данных, вы должны предоставить юридически достаточные заявления о конфиденциальности и получить необходимые согласия на обработку таких данных, а также вы гарантируете нам, что вы обрабатываете такие данные в соответствии с применимым законодательством. .',
    block18:
      '(а) Прекращение действия; Приостановка. Настоящие условия вступают в силу с момента первого использования вами Сервиса и остаются в силе до прекращения их действия. Вы можете прекратить действие настоящих условий в любое время по любой причине, прекратив использование Сервиса и Контента. Мы можем прекратить действие настоящих условий с предварительным уведомлением по любой причине. Мы можем немедленно прекратить действие настоящих условий, уведомив вас, если вы существенно нарушите Раздел 2 (Требования к использованию), Раздел 5 (Конфиденциальность, безопасность и защита данных), Раздел 8 (Разрешение споров) или Раздел 9 (Общие условия), или если наши изменения в отношениях с любым сторонним поставщиком технологий, находящимся вне нашего контроля, или для соблюдения требований закона или правительства. Мы можем приостановить ваш доступ к Сервису, если вы не соблюдаете эти условия, или если ваше использование представляет угрозу безопасности для нас или любой третьей стороны, или если мы подозреваем, что ваше использование является мошенническим или может подвергнуть нас или любую третью сторону ответственности. .',
    block19:
      '(b) Последствия прекращения действия. После прекращения действия вы прекратите использование Сервиса и незамедлительно вернете или уничтожите любую конфиденциальную информацию в соответствии с нашими указаниями. Положения настоящих условий, которые по своей природе должны оставаться в силе после прекращения действия или истечения срока действия, включая, помимо прочего, разделы 3 и 5–9, остаются в силе.',
    block2:
      'Настоящие Условия использования применяются к использованию вами услуг Noam, включая наши интерфейсы прикладного программирования, программное обеспечение, инструменты, услуги разработчиков, данные, документацию и веб-сайт (совместно именуемые «Услуги»). Используя наши Услуги, вы соглашаетесь соблюдать эти условия. Наша Политика конфиденциальности объясняет, как мы собираем и используем личную информацию.',
    block20:
      '(а) Компенсация. Вы будете защищать, возмещать убытки и ограждать нас, наших аффилированных лиц и наш персонал от любых претензий, убытков и расходов (включая гонорары адвокатов), возникающих в результате или связанных с использованием вами Сервиса, включая ваш Контент, ваши использование продуктов или услуг, связанных с Сервисом, а также нарушение вами настоящих условий или применимого законодательства.',
    block21:
      '(б) Отказ от ответственности. Сервис предоставляется «как есть». В той степени, в которой это разрешено законом, мы, наши аффилированные лица и лицензиары не делаем никаких заявлений и не даем никаких гарантий в отношении Сервиса и не даем никаких гарантий, включая, помимо прочего, гарантии коммерческой ценности, пригодности для конкретной цели, удовлетворительного качества, ненарушения авторских прав. и спокойное удовольствие, а также любые гарантии, возникающие в результате торговых операций или торговых операций. Мы не гарантируем, что Сервис будет работать бесперебойно, точно и без ошибок, а также что любой Контент будет безопасным, не будет утерян или не изменен.',
    block22:
      '(в) Ограничение ответственности. Ни мы, наши аффилированные лица, ни наши лицензиары не несем ответственности за любые косвенные, случайные, особые, косвенные или штрафные убытки, включая упущенную выгоду, потерю репутации, невозможность использования, потерю данных или другие нематериальные убытки, даже если нас уведомили о возможности такого ущерба. В соответствии с настоящими условиями наша общая ответственность не будет превышать Комиссию, которую вы заплатили за Услугу за двенадцать (12) месяцев, предшествующих предъявлению претензии, или сто долларов США (100 долларов США), в зависимости от того, что больше. Ограничения в этом разделе применяются в максимальной степени, разрешенной применимым законодательством.',
    block23:
      'Условия и использование вами Услуг регулируются законодательством США, за исключением норм коллизионного права США. Использование вами Приложения также может регулироваться другими местными, государственными, национальными или международными законами. Любые судебные иски или разбирательства, связанные с настоящими Условиями, будут рассматриваться исключительно в судах США, и вы соглашаетесь подчиняться личной юрисдикции таких судов.',
    block24:
      '(а) Отношения Сторон. Компания Noam и вы являетесь независимыми подрядчиками, и ни одна из сторон не имеет права представлять или связывать другую сторону или принимать на себя обязательства за другую сторону без предварительного письменного согласия другой стороны.',
    block25:
      '(б) Использование бренда. Вы не имеете права использовать название, логотипы или товарные знаки Noam или любого из ее аффилированных лиц без нашего предварительного письменного согласия.',
    block26:
      'Если какое-либо положение настоящих условий будет признано недействительным, незаконным или не имеющим исковой силы, остальные положения останутся в полной силе.',
    block3:
      'Если вам меньше 18 лет, вы должны получить разрешение от своих родителей или законных опекунов на использование Сервиса. Если вы используете Сервис от имени другого физического или юридического лица, вы должны быть уполномочены принять эти условия от его имени. Для регистрации учетной записи вы должны предоставить точную и полную информацию. Вы не имеете права предоставлять свои учетные данные или учетную запись кому-либо за пределами вашей организации, и вы несете ответственность за все действия, осуществляемые с использованием ваших учетных данных.',
    block4:
      '(а) Использование Сервиса. Вы можете получить доступ к Сервису в соответствии с настоящими условиями, и мы предоставляем вам неисключительное право на использование Сервиса. При использовании Сервиса вы обязуетесь соблюдать настоящие условия и все применимые законы. Мы и наши аффилированные лица владеем всеми правами, титулами и интересами в отношении Сервиса.',
    block5:
      '(б) Обратная связь. Мы приветствуем отзывы, комментарии, идеи, предложения и улучшения. Если вы предоставляете такой контент, мы можем использовать его без каких-либо ограничений и без какой-либо компенсации вам.',
    block6:
      '(в) Ограничения. Вы не имеете права: (1) использовать Сервис способом, который нарушает, присваивает или нарушает какие-либо права других лиц; (2) перепроектировать, декомпилировать, дизассемблировать, переводить или иным образом пытаться обнаружить исходный код или базовые компоненты моделей, алгоритмов и систем Сервиса (если такие ограничения не запрещены действующим законодательством); (3) использовать результаты Сервиса для разработки моделей, конкурирующих с Noam; (4) извлекать данные или выходные данные из Сервиса с использованием любых автоматизированных или программных методов, если это не разрешено через API, включая очистку, сбор веб-страниц или извлечение веб-данных; (5) представлять результаты работы Сервиса как искусственно созданные, хотя это не так, или иным образом нарушать нашу политику использования; (6) покупать, продавать или передавать ключи API без нашего предварительного согласия; или (7) предоставить нам любую личную информацию детей в возрасте до 13 лет или применимого возраста цифрового согласия. Вы обязуетесь соблюдать любые ограничения по скорости и другие требования, указанные в нашей документации.',
    block7:
      '(г) Сторонние услуги. Любое стороннее программное обеспечение, услуги или другие продукты, связанные с Сервисом, регулируются собственными условиями, и мы не несем ответственности за сторонние продукты.',
    block8:
      '(а) Ваш контент. Вы можете предоставлять входные данные («Входные данные») для Сервиса и получать выходные данные («Выходные данные»), сгенерированные и возвращаемые на основе Входных данных (совместно именуемые «Контент»). В отношениях между сторонами и в пределах, разрешенных применимым законодательством, вы владеете всеми Вводимыми данными. Noam может использовать Контент для предоставления и обслуживания Сервиса, соблюдения действующего законодательства и обеспечения соблюдения наших политик. Вы несете ответственность за Контент, включая обеспечение того, чтобы он не нарушал применимое законодательство или настоящие условия.',
    block9:
      '(б) Точность. Искусственный интеллект и машинное обучение — быстро развивающиеся области исследований. Мы постоянно стремимся улучшить наш сервис, чтобы сделать его более точным, надежным, безопасным и выгодным. Учитывая вероятностный характер машинного обучения, использование нашего сервиса в некоторых случаях может привести к получению неправильных результатов, которые могут неточно отражать реальных людей, места или факты. Вам следует соответствующим образом оценить точность любых выходных данных в зависимости от вашего варианта использования, в том числе путем проверки выходных данных вручную.',
    subTitle1: 'Регистрация и доступ',
    subTitle10: 'Делимость',
    subTitle2: 'Требования к использованию',
    subTitle3: 'Содержание',
    subTitle4: 'Сборы и оплата',
    subTitle5: 'Конфиденциальность, безопасность и защита данных',
    subTitle6: 'Срок действия и прекращение действия',
    subTitle7: 'Компенсация; Отказ от ответственности; Ограничение ответственности',
    subTitle8: 'Применимое право и юрисдикция',
    subTitle9: 'Общие условия',
    title: 'Условия использования',
    updateTime: 'Обновлено: 15 марта 2024 г.',
  },
  trialModal: {
    btn: 'Начните прямо сейчас (всего $0,99)',
    chat: 'ЧатPDF',
    desc1:
      'После пробного периода с вас будет взиматься ежегодная плата в размере 180 долларов США.',
    desc2: 'Отменить в любое время',
    focus: 'Фокусировка',
    hover: 'Наведите курсор на перевод',
    image: 'Перевод изображения',
    installBtn: 'Установите сейчас, чтобы получить подарок',
    memo: 'Управление избранным',
    pdf: 'PDF параллельный перевод',
    realtime: 'Мгновенный перевод',
    select: 'Перевод подбора слов',
    title: 'Приветственный подарок',
    trialText: '7-дневная пробная версия',
    video: 'Видео перевод',
    videoSummary: 'Видео-резюме',
    web: 'Параллельный перевод',
    webSummary: 'Веб-сводка',
  },
  upgradeModal: {
    btn: 'Обновите сейчас',
    chat: { free: 'Вы достигли лимита ChatPDF.', pro: 'Вы достигли лимита ChatPDF в этом месяце.' },
    contactStr:
      'Пожалуйста, дождитесь следующего сброса или свяжитесь с нами по адресу contact@noam.tools.',
    limitAlertStr: 'Вы достигли лимита бесплатного плана. Обновите, чтобы продолжить.',
    more: 'Посмотреть планы',
    pageLimit: { free: 'Вы достигли лимита страниц PDF.' },
    title: 'Напоминание',
    upgradeAlertStr: 'Вы достигли лимита бесплатного плана. Обновите, чтобы продолжить.',
    upload: {
      free: 'Вы достигли лимита на перевод PDF-файлов.',
      pro: 'Вы достигли лимита на переводы PDF в этом месяце.',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Присоединяйтесь сейчас',
      label: 'Преимущества для новых пользователей:',
      remain: 'осталось всего 30',
      text: 'Доступно всего 100 мест! Возьмите свой сейчас!',
    },
  },
}

export default TRANSLATION
